import { useEffect, useState } from 'react'

import {
  FullscreenVideoElement,
  UseVideoFullscreenOptions
} from './useVideoFullscreen.types'

export const useVideoFullscreen = ({
  playerRef,
  videoRef
}: UseVideoFullscreenOptions) => {
  const [isFullscreen, setIsFullscreen] = useState(false)

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(document.fullscreenElement === playerRef.current)
    }

    document.addEventListener('fullscreenchange', handleFullscreenChange)
    return () =>
      document.removeEventListener('fullscreenchange', handleFullscreenChange)
  }, [playerRef])

  const toggleFullscreen = () => {
    if (document.fullscreenElement) {
      void document.exitFullscreen?.().catch(() => undefined)
      return
    }

    if (playerRef.current?.requestFullscreen) {
      void playerRef.current.requestFullscreen().catch(() => undefined)
      return
    }

    ;(
      videoRef.current as FullscreenVideoElement | null
    )?.webkitEnterFullscreen?.()
  }

  return { isFullscreen, toggleFullscreen }
}
